module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0143.jpg?v=fb5518c5";